<template>
    <div>
        <v-alert type="error" outlined>
            <h1 v-if="!errorCode && !errorText && !errorMsg">Error please try to log in again</h1>
            {{errorCode}}<br>
            {{errorText}}<br>
            {{errorMsg }}<br>
        </v-alert>

        
        <v-btn
            large
            color="primary"
            to="/"
            >
            Home
        </v-btn>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  name: "error",
  data: () => ({
    errorCode: null,
    errorText: null,
    errorMsg: null
  }),
  methods: {
    
  },
  mounted ()  {
      this.errorCode = this.$route.query.errorCode
      this.errorText = this.$route.query.errorText
      this.errorMsg = this.$route.query.errorMsg
  }
});
</script>

